import {InstagramTokenLoaderClass} from "./instagram-token-loader.class";

export class InstagramFeedClass {
    private readonly containerSelector = '.js-instagram-feed';

    private readonly container: HTMLElement;
    private initted = false;

    constructor() {
        this.container = document.querySelector(this.containerSelector);
    }

    init (): Promise<void> {
        if (this.initted) {
            return;
        }

        this.initted = true;
        return new Promise((resolve, reject) => {
            const instaFeed = new InstagramTokenLoaderClass();
            if (this.container) {
                // @ts-ignore
                return instaFeed.init()
                    .then(_ => resolve())
                    .catch(_ => reject());
            } else {
                reject();
            }
        });
    }
}
